"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useFlatTreeNavigation", {
    enumerable: true,
    get: function() {
        return useFlatTreeNavigation;
    }
});
const _reactsharedcontexts = require("@fluentui/react-shared-contexts");
const _reactutilities = require("@fluentui/react-utilities");
const _nextTypeAheadElement = require("../../utils/nextTypeAheadElement");
const _tokens = require("../../utils/tokens");
const _treeItemFilter = require("../../utils/treeItemFilter");
const _useRovingTabIndexes = require("../../hooks/useRovingTabIndexes");
const _getTreeItemValueFromElement = require("../../utils/getTreeItemValueFromElement");
function useFlatTreeNavigation() {
    const { targetDocument } = (0, _reactsharedcontexts.useFluent_unstable)();
    const { rove, initialize } = (0, _useRovingTabIndexes.useRovingTabIndex)(_treeItemFilter.treeItemFilter);
    function getNextElement(data, walker) {
        if (!targetDocument) {
            return null;
        }
        switch(data.type){
            case _tokens.treeDataTypes.Click:
                return data.target;
            case _tokens.treeDataTypes.TypeAhead:
                walker.currentElement = data.target;
                return (0, _nextTypeAheadElement.nextTypeAheadElement)(walker, data.event.key);
            case _tokens.treeDataTypes.ArrowLeft:
                {
                    const nextElement = parentElement(data.parentValue, walker);
                    if (!nextElement && process.env.NODE_ENV !== 'production') {
                        // eslint-disable-next-line no-console
                        console.warn(`@fluentui/react-tree [useFlatTreeNavigation]:
\'ArrowLeft\' navigation was not possible.
No parent element found for the current element:`, data.target);
                    }
                    return nextElement;
                }
            case _tokens.treeDataTypes.ArrowRight:
                {
                    walker.currentElement = data.target;
                    const nextElement = firstChild(data.target, walker);
                    if (!nextElement && process.env.NODE_ENV !== 'production') {
                        const ariaLevel = Number(data.target.getAttribute('aria-level'));
                        // eslint-disable-next-line no-console
                        console.warn(`@fluentui/react-tree [useFlatTreeNavigation]:
\'ArrowRight\' navigation was not possible.
No element with "aria-posinset=1" and "aria-level=${ariaLevel + 1}"
was found after the current element!`, data.target);
                    }
                    return nextElement;
                }
            case _tokens.treeDataTypes.End:
                walker.currentElement = walker.root;
                return walker.lastChild();
            case _tokens.treeDataTypes.Home:
                walker.currentElement = walker.root;
                return walker.firstChild();
            case _tokens.treeDataTypes.ArrowDown:
                walker.currentElement = data.target;
                return walker.nextElement();
            case _tokens.treeDataTypes.ArrowUp:
                walker.currentElement = data.target;
                return walker.previousElement();
        }
    }
    const navigate = (0, _reactutilities.useEventCallback)((data, walker)=>{
        const nextElement = getNextElement(data, walker);
        if (nextElement) {
            rove(nextElement);
        }
    });
    return {
        navigate,
        initialize
    };
}
function firstChild(target, treeWalker) {
    const nextElement = treeWalker.nextElement();
    if (!nextElement) {
        return null;
    }
    const nextElementAriaPosInSet = nextElement.getAttribute('aria-posinset');
    const nextElementAriaLevel = nextElement.getAttribute('aria-level');
    const targetAriaLevel = target.getAttribute('aria-level');
    if (nextElementAriaPosInSet === '1' && Number(nextElementAriaLevel) === Number(targetAriaLevel) + 1) {
        return nextElement;
    }
    return null;
}
function parentElement(parentValue, treeWalker) {
    if (parentValue === undefined) {
        return null;
    }
    return treeWalker.root.querySelector(`[${_getTreeItemValueFromElement.dataTreeItemValueAttrName}="${parentValue}"]`);
}
